import { Button, Card, Col, Form, Input, message, Row, Spin } from 'antd';
import { JaaSMeeting, JitsiMeeting } from '@jitsi/react-sdk';
import moment from 'moment';

import { BaseComponent, PageError } from 'src/components';
import { lib, request } from 'src/Utils';
import DialogStartMeeting from './DialogStartMeeting';
import appConfig from 'src/config/app';

class VideoMeeting extends BaseComponent {
  constructor(props) {
    super(props)

    const params = lib.getObjParam(props.location.search)
    this.setIsLinkValid(params.exp)

    console.log('currentUser', lib.ls.getCurrentUser())
    this.myProfile = lib.ls.getCurrentUser()
    // this.isLinkExpired = moment(params.exp).diff(moment()) <= 0

    // this.readOnly = this.myProfile?.is_owner ||
    //   this.myProfile.is_admin

    this.initState({
      errorResponse: null,
      loading: false,
      visibleMeeting: false,
      managerTeams: [],
    })
  }

  readUserTeams = () => {
    this.setState({ loading: true }, () => {
      request({
        urlKey: 'read-userTeams',
        data: { limit: 100 },
        onSuccess: (res) => {
          console.log('teams', res)
          const managerTeams = res.data.results.filter(val => val.manager.id === this.myProfile.id)
  
          this.setState({ loading: false, errorResponse: null, managerTeams })
        },
        onFailed: (error) => {
          console.log('failed', error)
          this.setState({ loading: false, errorResponse: error.response })
        },
      })
    })
  }

  getDialogVisible = () => {
    const params = lib.getObjParam(this.props.location.search)
    return (this.isLinkValid && params.room)
  }

  // getAllowCreateMeeting = () => this.myProfile?.is_owner
  //   || this.state.managerTeams.length > 0

  setIsLinkValid = (exp) => {
    if (exp)
      this.isLinkValid = moment(exp).diff(moment()) > 0

    console.log('setIsLinkValid', this.isLinkValid)
  }

  generateMeetingPath = (room = '') => (
    '/video-meeting' +
    lib.getStrParam({
      room,
      exp: moment().add(10, 'minutes').utc().format(),
    })
  )

  openMeeting = (room) => {
    const exp = moment().add(10, 'minutes').utc().format()
    const roomName = (appConfig.meet.prefix_room || '') + room // supaya di dev tidak mempengaruhi live
    const meetingPath = '/video-meeting' + lib.getStrParam({ room: roomName.replace(/ /g, '-'), exp })

    this.setIsLinkValid(exp)

    this.props.history.replace(meetingPath)
  }

  joinMeeting = () => {
    this._form.validateFields().then(values => {
      this.setState({ loading: true }, async () => {
        await new Promise(resolve => setTimeout(resolve, 1000))
        this.openMeeting(values.room)

        this.setState({ loading: false })
      })
    }).catch(() => null)
  }

  endMeeting = () => {
    this.props.history.replace(this.props.location.pathname)
  }

  didMount() {
    // this.readUserTeams()
    window.addEventListener('beforeunload', (event) => {
      if (this.getDialogVisible()) {
        event.preventDefault()
      }
    })
  }

  render() {
    const params = lib.getObjParam(this.props.location.search)
    console.log('Rendered', {params}, this)

    // const isExpired = moment(params.exp).diff(moment()) <= 0

    // if (this.state.errorResponse && !this.state.loading) {
    //   return (
    //     <div style={{ padding: '24px' }}>
    //       <Card>
    //         <PageError
    //           errorResponse={this.state.errorResponse}
    //           onReload={this.readUserTeams}
    //         />
    //       </Card>
    //     </div>
    //   )
    // }

    return (
      <div style={{ height: '100vh', padding: '24px' }}>
        {/* --------- DIALOGS --------- */}
        <DialogStartMeeting
          visible={this.getDialogVisible()}
          room={params.room}
          generateMeetingPath={this.generateMeetingPath}
          onClose={this.endMeeting}
        />

        <Row className="h-100" justify="center" align="middle" style={{ width: '100%' }}>
          <Col>
            <Card className="card-hovered" style={{ minWidth: '680px', maxWidth: '100%' }}>
              <div style={{ marginBottom: '24px' }}>
                <Row justify="center">
                  <Col>
                    <div style={{ fontSize: '24px', fontWeight: 500 }}>
                      TimeWise Meet
                    </div>
                  </Col>
                </Row>
              </div>
              <Form ref={this.onRefForm}>
                <Spin spinning={this.state.loading}>
                  {params.exp && !this.isLinkValid && (
                    <div style={{ color: 'red' }}>
                      The invitation link "{params.room}" has expired, please request a new link.
                    </div>
                  )}
                  <Row wrap={false} gutter={[12, 12]}>
                    <Col flex="auto">
                      <Form.Item name="room" rules={[{ required: true, message: 'Please type meeting name!' }]}>
                        <Input
                          autoFocus
                          placeholder="Type in the meeting name that you want to create or join:"
                          onPressEnter={this.joinMeeting}
                        />
                      </Form.Item>
                    </Col>
                    <Col flex="none">
                      <Button type="primary" onClick={this.joinMeeting} onMouseDown={e => e.preventDefault()}>
                        Start
                      </Button>
                    </Col>
                  </Row>
                </Spin>
              </Form>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

export default VideoMeeting